import React from "react";
import type { FC } from "react";
import { Link } from "react-router-dom";

import { Agreement } from "../agreement/agreement";

import "./styles.scss";

export const Footer: FC = () => (
    <>
        <Agreement />
        <div className="main-footer">
            <div className="main-footer__container">
                <div className="main-footer__social">
                    <a href="https://vk.com/so.perm" rel="noreferrer" target="_blank">
                        ВКонтакте
                    </a>
                    <a href="https://rutube.ru/channel/38203273/" rel="noreferrer" target="_blank">
                        RUTUBE
                    </a>
                </div>
                <div className="main-footer__contacts">
                    <span>+7 (342) 255 44 99</span>
                    <br />
                    <a href="mailto:help@rus-na5.ru">help@rus-na5.ru</a>
                    <br />
                    <span>614000, Пермь, ул. Николая Островского, 30</span>
                    <br />
                    ООО «Современное образование»
                    <br />
                    <Link to="/about/">Сведения об образовательной организации</Link>
                    <br />
                    <Link to="/requisites/">Реквизиты</Link>
                </div>
            </div>
        </div>
    </>
);
